import { SelectChangeEvent } from '@mui/material';
import { useCallback } from 'react';
import { StageNodeData } from '@bandido/shared/types';

interface UseStageFormProps {
  selectedStageId?: string;
  onStageChange: (id: string, data: Partial<StageNodeData>) => void;
}

export const useStageForm = ({ selectedStageId, onStageChange }: UseStageFormProps) => {
  const handleTextChange = useCallback(
    (field: string) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      if (!selectedStageId) return;
      onStageChange(selectedStageId, { [field]: e.target.value });
    },
    [selectedStageId, onStageChange],
  );

  const handleSelectChange = useCallback(
    (field: string) => (e: SelectChangeEvent) => {
      if (!selectedStageId) return;
      onStageChange(selectedStageId, { [field]: e.target.value });
    },
    [selectedStageId, onStageChange],
  );

  const removeAudio = useCallback(
    (type: 'record' | 'file') => {
      if (!selectedStageId) return;
      if (type === 'record') {
        onStageChange(selectedStageId, {
          audioUrl: '',
        });
      } else {
        onStageChange(selectedStageId, {
          fileUrl: '',
        });
      }
    },
    [selectedStageId, onStageChange],
  );

  return {
    handleTextChange,
    handleSelectChange,
    removeAudio,
  };
};
